import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'

function Section3({data}) {
    return (
        <div id="section3" className="section3 mt-scroll scroll-div" style={{ backgroundColor: '#f0e7da' }}>
            {/* Gotham Font Implementation */}
            <style>
                {`
                /* Gotham Font Faces - Replace URLs with your actual font file paths */
                @font-face {
                    font-family: 'Gotham';
                    src: url('/fonts/Gotham-Book.woff2') format('woff2'),
                         url('/fonts/Gotham-Book.woff') format('woff');
                    font-weight: 400;
                    font-style: normal;
                    font-display: swap;
                }
                
                @font-face {
                    font-family: 'Gotham';
                    src: url('/fonts/Gotham-Medium.woff2') format('woff2'),
                         url('/fonts/Gotham-Medium.woff') format('woff');
                    font-weight: 500;
                    font-style: normal;
                    font-display: swap;
                }
                
                @font-face {
                    font-family: 'Gotham';
                    src: url('/fonts/Gotham-Bold.woff2') format('woff2'),
                         url('/fonts/Gotham-Bold.woff') format('woff');
                    font-weight: 700;
                    font-style: normal;
                    font-display: swap;
                }
                
                /* Font Styling */
                .section-paragraph {
                    font-family: 'Gotham', 'Helvetica Neue', Helvetica, Arial, sans-serif;
                    font-weight: 400; /* Change to 500 for Medium weight */
                    line-height: 1.6;
                    letter-spacing: 0.2px;
                    color: #333333;
                }
                `}
            </style>
            
            <Container fluid className="me-0">
                <Row>
                    <Col md={6} className="px-0 d-flex align-items-end">
                        <Image 
                            src={"https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/OurMenu/our menu.webp"} 
                            className="side-image" 
                            data-aos="fade-up" 
                            data-aos-delay="500" 
                            data-aos-duration="2500" 
                            style={{ 
                                width: '100%', 
                                height: 'auto', 
                                objectFit: 'cover',
                                paddingBottom: '40px'
                            }}
                        />
                    </Col>
                    <Col md={6} className="m-auto section2-1" data-aos="fade-up" data-aos-delay="500" data-aos-duration="2500">
                        {/* OUR MENU header with inline styles - LEFT ALIGNED */}
                        <div>
                            <Image 
                                src="https://sqlvas774pizbiy4km.blob.core.windows.net/liveenvironment/website/mila/OurMenu/our menu_1.webp" 
                                alt="OUR MENU"
                                style={{
                                    maxWidth: '250px',
                                    width: '100%',
                                    height: 'auto',
                                    marginBottom: '20px'
                                }}
                            />
                        </div>
                        <p className="section-paragraph">
 
At Mila by Smoky, the shisha vibes are just the start — the food and drinks shine just as bright. Expect a crowd-pleasing lineup of easy, flavour-forward bites like Signature Dips, Crispy Calamari, Lobster Tacos, and Wagyu Sliders, plus lighter options like Octopus and Greek Salads. Sushi lovers can explore Yellowtail Carpaccio, Tuna Tartare, and Lobster Roll, while heartier mains — from Grilled Octopus to Seabass, Steak Tenderloin, and Truffle Mushroom Burger — bring depth to every visit.
 
To complement the menu, signature cocktails like the citrusy Cortez Century, botanical Aurora, and spiced Maita’i Escape are crafted to pair perfectly with mellow beachside vibes and smooth shisha sessions.
                        </p>
                        <div>
                            <div className="mw-300">
                                <a 
                                    href={"https://digimenu.milabysmoky.com/?slug=smokymila"} 
                                    className="btn btn-primary py-2 px-4 fs-5"
                                    style={{
                                        backgroundColor: '#003594',
                                        borderColor: '#003594',
                                        fontWeight: 'bold',
                                        borderRadius: '25px',
                                        textDecoration: 'none'
                                    }}
                                >
                                    SEE MENU HERE
                                </a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Section3;